<template>
  <section class="payment-methodes">
    <h2 class="payment-methodes__subtitle">{{ $t('payment.methods.title') }}</h2>
    <ul>
      <li
        v-for="method in paymentMethods"
        :key="method.code"
      >
        <RadioButton
          :id="`payment-method-${method.code}`"
          name="paymentMethod"
          :value="method.code"
          v-model="localSelectedPaymentMethod"
        >
          <div class="payment-methodes__info">
            <h3>
              {{ method.code === 'ADYEN_ADYEN_CC_DIRECT' ? $t('payment.methods.card') : (method.name || method.method_code) }}
            </h3>
            <p class="payment-methodes__description">
              {{ method.description }}
            </p>
          </div>
        </RadioButton>
        <svg class="payment-methodes__icon">
          <use :xlink:href="`#${method.code === 'ADYEN_VIPPS' ? vipps : visa}`" />
        </svg>
      </li>
    </ul>
  </section>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue'
import RadioButton from '@/components/BaseComponents/RadioButton.vue'
import visa from '@/assets/icons/visa.svg'
import vipps from '@/assets/icons/vipps.svg'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'PaymentMethodes',
  components: {
    RadioButton,
  },
  props: {
    paymentMethods: {
      type: Array as PropType<any[]>,
      required: true,
    },
    selectedPaymentMethod: {
      type: String,
      required: true,
    },
  },
  emits: ['update:selectedPaymentMethod'],
  setup(props, { emit }) {
    const { t } = useI18n()

    const localSelectedPaymentMethod = computed({
      get: () => props.selectedPaymentMethod,
      set: (value) => emit('update:selectedPaymentMethod', value),
    })

    return {
      localSelectedPaymentMethod,
      visa,
      vipps,
      t,
    }
  },
})
</script>

<style lang="scss" scoped>
.payment-methodes {
  &__subtitle {
    margin: 1.563rem 0;
    @include title-medium;
  }

  &__info {
    width: 100%;

    h3 {
      @include title-medium;
      margin: 0 0 0.5rem 0;
    }

    p {
      @include body-large;
      margin: 0;
    }
  }

  &__icon {
    width: 61.54px;
    height: 20px;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;

    li {
      cursor: pointer;
      padding: 1rem;
      display: block;
      border: 1px solid $clr-primary-100;
      border-radius: $border-radius;
      margin-bottom: 0.5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      input:checked + li {
        background-color: $clr-primary;
        color: $clr-white;
        border-color: $clr-secondary;
      }
    }
  }
}
</style>